import { render, staticRenderFns } from "./AuthTable.vue?vue&type=template&id=4f0d5a88&scoped=true"
import script from "./AuthTable.vue?vue&type=script&lang=js"
export * from "./AuthTable.vue?vue&type=script&lang=js"
import style0 from "./AuthTable.vue?vue&type=style&index=0&id=4f0d5a88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0d5a88",
  null
  
)

export default component.exports